export const START_YEAR_PRODUCTION = 1890;
export const START_YEAR_OPTIONS = 1980;
export const CURRENT_YEAR = new Date().getFullYear();